import React from "react";
import TlvCoronaMap from "./components/tlv_coronamap";
import { layerData } from "./layers-data/layer_props";

function App() {
  return (
    <div>
      <TlvCoronaMap layerData={layerData}></TlvCoronaMap>
    </div>
  );
}

export default App;
